<template>
    <div class="mediaField">
        <div
            v-if="!media"
            :class="{'isSmall': small}"
            class="triggerMediaLibrary"
            @click="libraryOpen = true"
        >
            <div class="imageHolder flex items-center justify-center">
                <svg v-if="type !== 'image'" svg-inline="" class="placeholderIcon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
                <svg v-if="type === 'image'" svg-inline="" class="placeholderIcon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
            </div>
            <p
                v-if="type !== 'image'"
                class="title"
            >
                No media is selected
            </p>
        </div>
        <MediaItem
            v-else
            :item="media"
            :small="small"
            @updateItem="mediaDialogOpen = true"
            @removeItem="media = false"
        />
        <portal to="endOfPage">
            <AppDialog
                v-if="libraryOpen"
                :close-click-outside="false"
                :full-width="true"
                @close="libraryOpen = false"
            >
                <Medialibrary
                    :pick-item="true"
                    :is-popup="true"
                    :type-to-pick="type"
                    :disabled-items="disabledItems"
                    @itemPicked="itemPicked"
                />
            </AppDialog>

            <DialogMediaItem
                v-if="mediaDialogOpen"
                :item="media"
                heading="Update item"
                @altUpdated="val => media.alt = val"
                @close="mediaDialogOpen = null"
            >
                <template v-slot:topIcon>
                    <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"/><path d="M18 2l4 4-10 10H8v-4L18 2z"/></svg>
                </template>
            </DialogMediaItem>
        </portal>
    </div>
</template>

<script>
import AppDialog from '../dialog/AppDialog.vue';
import Medialibrary from '../media-library/MediaLibrary.vue';
import MediaItem from '../media-library/MediaItem.vue';
import DialogMediaItem from '../media-library/DialogMediaItem.vue';

export default {
    components: {
        AppDialog,
        Medialibrary,
        MediaItem,
        DialogMediaItem,
    },
    props: {
        initialMedia: {
            type: Object,
            default: null,
        },
        type: {
            type: String,
            default: 'all',
        },
        disabledItems: {
            type: Array,
            default: null,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        media: null,
        libraryOpen: false,
        mediaDialogOpen: false,
    }),
    created() {
        if (this.initialMedia && this.initialMedia.source) {
            this.media = this.initialMedia;
        }
    },
    methods: {
        itemPicked(media) {
            this.libraryOpen = false;
            this.media = media;
            this.$emit('changed', this.media);
        },
    },
};
</script>

<style lang="postcss" scoped>
.mediaField {
    width: 225px;
    @media (--laptop) {
        width: 180px;
    }
}
.triggerMediaLibrary {
    cursor: pointer;
}
.imageHolder {
    width: 100%;
    padding: 46% 0;
    background-color: var(--grey100);
    border: 1px solid var(--borderColor);
    position: relative;
    border-radius: var(--borderRadius);
    overflow: hidden;
}
.placeholderIcon {
    width: 40px;
    height: 40px;
    color: var(--grey500);
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -20px;
    margin-top: -20px;
    @media (--laptop) {
        width: 30px;
        height: 30px;
        margin-left: -15px;
        margin-top: -15px;
    }
}
.title {
    font-size: 15px;
    margin-top: 10px;
    @media (--laptop) {
        font-size: 14px;
    }
}
.imageUpload:hover .mediaItemBar {
    opacity: 1;
}
.isSmall .placeholderIcon {
    width: 30px;
    height: 30px;
    margin-left: -15px;
    margin-top: -15px;
}
.isSmall .imageHolder {
    padding: 15px;
    min-height: 90px;
}
</style>
